export default function Marquee({ items = [], className = "" }) {
  const list = [...items, ...items, ...items];
  return (
    <div className={`overflow-hidden py-8 md:py-12 border-y border-[#D9D4C7] ${className}`} data-testid="marquee">
      <div className="marquee-track">
        {list.map((label, i) => (
          <span
            key={i}
            className="font-display text-[14vw] md:text-[8vw] leading-none px-8 flex items-center gap-8"
          >
            {label}
            <span className="text-[#8C7A6B]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
